import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from 'lucide-react';
import { Badge } from './badge.js';
/**
 * `Badge` with a trailing remove button (lucide `X`) — the shared shape behind
 * the multiselect chip summary, the chip-input widget and the removable tag
 * chip (`ui-domain/TagChip`). The ONE remove affordance of the kit: a chip
 * that needs its own «×» takes it from here rather than hand-rolling a button.
 */
export function RemovableBadge({ children, onRemove, removeAriaLabel, disabled, variant = 'neutral', size, className, }) {
    return (_jsxs(Badge, { variant: variant, size: size, className: className, children: [children, _jsx("button", { type: "button", "aria-label": removeAriaLabel, className: "ml-1 shrink-0 text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)]", onClick: onRemove, disabled: disabled, children: _jsx(X, { "aria-hidden": true, className: "h-3 w-3", strokeWidth: 2.5 }) })] }));
}
//# sourceMappingURL=removable-badge.js.map